export function clientLoginContext(info:any,orgId:number){
 const current=Number(info?.id)===Number(orgId)?info:{}
 const name=String(current.orgShortName || current.orgName || current.name || (orgId===1000?'蓝迪云平台':'当前店铺'))
 const logo=String(current.logoUrl1 || current.logoUrl || '')
 return {name,logo,kind:orgId===1000?'平台客户端':'本店客户端',hint:orgId===1000?'请使用平台客户账号登录':'请使用本店客户账号登录'}
}
